import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":_vm.displayText,"items":_vm.roleList,"multiple":_vm.multiple,"chips":_vm.multiple,"item-text":"label","item-value":"name","clearable":_vm.clearable,"rules":[_vm.requiredCheck()],"outlined":""},model:{value:(_vm.securityRolesValue),callback:function ($$v) {_vm.securityRolesValue=$$v},expression:"securityRolesValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }